import grapesjs from 'drapcode-builder';
import loadTraits from './traits';

export default grapesjs.plugins.add('webconnect-href-traits', (editor, opts = {}) => {
  const default_traits = {
    type: 'webconnect-href',
    name: 'href',
    label: false,
  };
  let options = {
    ...{
      traits: default_traits,
    },
    ...opts,
  };
  loadTraits(editor, options);
});
